import { render, staticRenderFns } from "./resultLmsQuizReport.vue?vue&type=template&id=59e74b10&"
import script from "./resultLmsQuizReport.vue?vue&type=script&lang=js&"
export * from "./resultLmsQuizReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports